



























































































































import { PropType } from 'vue';
import { DataTableHeader } from 'vuetify';
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';

import {
  Configuration,
  ConfigurationItem
} from '@/models/configurator/configuration';
import { QuoteProductItem, QuoteProductCategory } from '@/models/quote';

import mixins, { ExtractVue } from '@/utils/mixins';
// components
import VueDraggable from 'vuedraggable';
import draggable from '@/mixins/draggable';
import auth from '@/mixins/auth';

// utils
import { compareOrder, roundCurrency } from '@/utils/helpers';

// components
import ConfigurableItemFormDialog from '@/components/configurator/congifuration/ConfigurableItemFormDialog.vue';
import { ErrorManager } from '@/models/error';

export default mixins(draggable, auth).extend({
  components: {
    VueDraggable,
    ConfigurableItemFormDialog
  },
  props: {
    configuration: {
      type: Object as PropType<Configuration>
    },

    configurationItems: {
      type: Array as PropType<ConfigurationItem[]>
    },

    quoteProductCategory: Object as PropType<QuoteProductCategory>,

    product: {
      type: Object as PropType<QuoteProductItem>
    },

    quoteId: Number,
    quoteRevision: Number,
    exchangeRate: Number,
    currencyCode: String,
    snapshot: Number,
    onlyUnitCost: Boolean
  },

  data() {
    return {
      updateOrderMode: false,
      orderLoading: false,
      proxyItems: [] as ConfigurationItem[],
      search: '',
      errorMessage: ''
    };
  },

  computed: {
    configurationItemsHeaders() {
      const headers = [
        {
          text: '',
          align: 'start',
          sortable: false,
          value: 'drag',
          width: '60'
        },
        {
          text: '',
          value: 'manually_updated_fields',
          sortable: false,
          width: 30
        },
        {
          text: 'Items',
          align: 'start',
          sortable: false,
          value: 'item',
          width: '240'
        },
        {
          text: 'Unit Price',
          value: 'unit_price',
          sortable: false,
          width: '180'
        },
        {
          text: 'Discount',
          align: 'start',
          value: 'discount',
          sortable: false,
          width: '150'
        },
        {
          text: 'Net Unit Price',
          align: 'start',
          sortable: false,
          width: '120'
        },
        {
          text: 'Quantity',
          align: 'center',
          value: 'quantity',
          sortable: false,
          width: '120'
        },
        {
          text: 'U/M',
          align: 'center',
          value: 'unit',
          sortable: false,
          width: '80'
        },
        {
          text: 'Total Price',
          align: 'start',
          sortable: false,
          width: '120'
        }
      ] as DataTableHeader[];

      if (this.isUserQuoteAdmin) {
        // Item unit cost is always in Canadian dollar
        headers.push({
          text: 'Unit Cost (CAD)',
          value: 'unit_cost',
          align: 'start',
          sortable: false,
          width: '120'
        });
      }

      headers.push({
        text: '',
        align: 'center',
        sortable: false,
        value: 'actions',
        width: '120'
      });
      return headers;
    },

    configurationPriceTotal(): number {
      return this.configurationItems.reduce(
        (acc, cur) =>
          acc +
          (roundCurrency(cur.unit_price! * this.exchangeRate) -
            roundCurrency(cur.unit_discount! * this.exchangeRate)) *
            cur.quantity!,
        0
      );
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },

  mounted() {
    // set proxyItems to be an updatable value based on parent
    this.proxyItems = cloneDeep(this.configurationItems);
  },

  watch: {
    // watch configuration items for changes and update proxyitems to be
    // a local updatable value without use of the store
    configurationItems: {
      handler() {
        this.proxyItems = cloneDeep(this.configurationItems);
      },
      deep: true
    }
  },

  methods: {
    // copy item to not update reference value
    cloneDeep,

    ...mapActions({
      updateConfigurationItemOrder: 'quote/updateConfigurationItemOrder'
    }),

    updateConfigurationItem() {
      this.$emit('update:configuration-items');
    },

    clearAllErrors(): void {
      this.errorMessage = '';
    },

    cancelItemOrderList() {
      this.proxyItems = this.configurationItems;
      this.updateOrderMode = false;
    },

    async setItemOrderList() {
      const difference: ConfigurationItem[] = this.proxyItems.filter(
        compareOrder(this.configurationItems)
      );

      this.clearAllErrors();

      if (difference.length) {
        this.orderLoading = true;

        await Promise.all(
          difference.map(async item => {
            await this.updateConfigurationItemOrder({
              id: this.quoteId,
              revision: this.quoteRevision,
              quoteProductCategory: this.quoteProductCategory.id,
              item
            }).catch(error => {
              this.errorMessage = ErrorManager.extractApiError(error);
            });
          })
        );

        this.orderLoading = false;
        this.updateConfigurationItem();
      }

      this.updateOrderMode = false;
    },

    updateItemOrder() {
      this.isDragging = false;

      this.clearAllErrors();

      // using proxyItems as the value itself is updated before function is called
      this.proxyItems.map((item, index: number) => {
        if (item.order !== index + 1) {
          item.order = index + 1;
        }
        return item;
      });
    },

    addConfigurationItem() {
      const dialog = this.$refs.configurableItemFormDialog as ExtractVue<
        typeof ConfigurableItemFormDialog
      >;
      dialog.open();
    },

    editConfigurationItem(configurationItem: ConfigurationItem) {
      const dialog = this.$refs.configurableItemFormDialog as ExtractVue<
        typeof ConfigurableItemFormDialog
      >;
      dialog.open(configurationItem, true);
    }
  }
});
